import { render, staticRenderFns } from "./PartidaList.vue?vue&type=template&id=06c1d4c2&scoped=true"
import script from "./PartidaList.vue?vue&type=script&lang=js"
export * from "./PartidaList.vue?vue&type=script&lang=js"
import style0 from "./PartidaList.vue?vue&type=style&index=0&id=06c1d4c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06c1d4c2",
  null
  
)

export default component.exports